// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__zL3sh","large":"styles_large__1mfFe"};